export default {
  title: "Нови резултати",
  subtitle: "Неодамна примени лабораториски резултати",
  comingSoon: "Наскоро",
  description: "Оваа функција ќе ги прикажува најновите примени лабораториски резултати.",
};
